export default __webpack_public_path__ + "static/media/poster-competition.cf5234de.webp";